import { BehaviorSubject, forkJoin } from 'rxjs';
import { ApiService } from '../api/api.service';
import { AppLoaderService } from '../app-loader/app-loader.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppInitializerService {
  public appData$ = new BehaviorSubject<any>(null);
  public isInitialized = false;

  constructor(
    private apiService: ApiService,
    private appLoaderService: AppLoaderService,
  ) {}

  async initializeApp(): Promise<void> {
    try {
      await this.apiService.getApiUrl();

      const data = await forkJoin({
        categoryData: this.appLoaderService.getCategories(),
        settings: this.appLoaderService.updateSettings(),
      }).toPromise();

      this.appData$.next(data);
      this.isInitialized = true;

    } catch (err) {
      console.error('App initialization failed', err);
      throw err;
    }
  }
}

// import { Injectable } from '@angular/core';
// import { forkJoin, of } from 'rxjs';

// import { AppLoaderService } from '../app-loader/app-loader.service';
// import { ApiService } from '../api/api.service';

// @Injectable({
//   providedIn: 'root',
// })
// export class AppInitializerService {
//   private appData: any = {};
//   public isInitialized = false;

//   constructor(
//     private apiService: ApiService,
//     private appLoaderService :AppLoaderService,
//   ) {}

//   async initializeApp(): Promise<void> {
    
//     await this.apiService.getApiUrl();

//     return new Promise((resolve, reject) => {
//       forkJoin({
//         categoryData: this.appLoaderService.getCategories(),
//         venues: this.appLoaderService.getVenuesList(),
//         settings: this.appLoaderService.getMainAppSettings(),
//       }).subscribe({
//         next: (data) => {
//           this.appData = data;
//           this.isInitialized = true;
//           resolve();
//         },
//         error: (err) => {
//           console.error('App initialization failed', err);
//           reject(err);
//         },
//       });
//     });
//   }
// }